import React, {useEffect} from 'react'
import { Box } from '@mui/system'
import Sidebar from './sidebar'
import { Button } from '@mui/material';

import { DataGrid } from '@mui/x-data-grid';
import CustomToolbar from './CustomToolbarPrint';
import { useNavigate } from 'react-router-dom';


import { doc, addDoc, collection, query, getDocs, where } from "firebase/firestore"; 
import {db} from "../firebase.js";


export default function OfficeStaff() {
    const [rows, setRows] = React.useState([])

    let arr = [];
  
    useEffect( () => {
      test()
  
      async function test(){
        arr=[]
        getData()
      }
  
      setRows(arr)
      console.log(arr)
  
  }, []);
  
  async function getData (){
    console.log("me chala")
    let arr = []
    const q = query(collection(db, "employee"), where("location", "in", ["office", "fitter", "driver"]));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      let obj = doc.data();
      Object.assign(obj, {doc: doc.id});
      console.log(obj)
      arr.push(obj)
     });  
  
     setRows(arr)
  
  }
  
  
  
    const navigate = useNavigate();
    const columns = [
      //{ field: 'id', headerName: 'ID', width: 70 },
      { field: 'firstName', headerName: 'Name', width: 150 },
      //{ field: 'lastName', headerName: 'Last Name', width: 150 },
      // {
      //   field: 'age',
      //   headerName: 'Age',
      //   type: 'number',
      // },
      {
          field: 'startDate',
          headerName: 'Start Date',
          // type: 'number',
          width: 170 
          
        },
        { field: 'jobTitle', headerName: 'Job Title' , width: 150 },
        { field: 'location', headerName: 'Location' , width: 150 },
        // {
        //   field: "action",
        //   headerName: "",
        //   sortable: false,
        //   renderCell: (params) => {
        //     const onClick = (e) => {
             
              
        //       navigate("/profile");
        //     };
      
        //     return <Button onClick={onClick} style={{color: "#1c3261"}}>View Details</Button>;
        //   }
        // },
        
    
      
    ];
  
    const handleRowClick = (params) => {
      //console.log(params.row);
      navigate("/profile",{
        state: {
          employee: params.row,
        }
      });
    };
    
    return (
  
        
  
        <Box sx={{ display: 'flex' }}>
          <Sidebar />
       
         
          <Box component="main" sx={{ flexGrow: 1, p: 3 }} style={{marginTop: "50px", justifyContent: "center", alignItems: "center"}}>
         
          <div style={{ height: 640, width: '100%'}}>
              <DataGrid
                  rows={rows}
                  columns={columns}
                  pageSize={10}
                  rowsPerPageOptions={[5]}
                  //checkboxSelection
                  onRowDoubleClick={handleRowClick}
                  components={{
                    Toolbar: CustomToolbar,
                  }}
              />
          </div>
          
        </Box>
       
          
      </Box>
  
      
    )
}
